export default __webpack_public_path__ + "static/media/05A.015.414f6580.png";